import type { CommandProperties } from '@atlassian/rovo-content-bridge-api';

import { log } from '../utils/aifc-logging';

import { CommandHandler, type PassThroughCommandProps } from './command-handler';

export class AbortCommandHandler extends CommandHandler<CommandProperties, void> {
	constructor(
		props: PassThroughCommandProps,
		private onAbort: () => void,
	) {
		super(props);
	}

	execute() {
		log('handle rovo-stream-aborted-command');
		try {
			this.onAbort();
		} catch {
			// TODO: EDITOR-123 - report this error
		}
	}
}
